import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom Zia Compass Icon for in-app navigation
 * Based on the New Mexico Zia symbol merged with compass directions
 * Cyberpunk aesthetic with neon glow effects
 */
const ZiaCompassIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 512 512">
      <defs>
        {/* Neon cyan glow */}
        <filter id="ziaGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="8" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        
        {/* Gradient for the center sun */}
        <radialGradient id="ziaSunGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fbbf24"/>
          <stop offset="100%" stopColor="#f59e0b"/>
        </radialGradient>
        
        {/* Cyan gradient for rays */}
        <linearGradient id="ziaCyanGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00f0ff"/>
          <stop offset="100%" stopColor="#06b6d4"/>
        </linearGradient>
      </defs>
      
      {/* Background circle - subtle */}
      <circle cx="256" cy="256" r="240" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.2"/>
      
      {/* Cardinal direction markers */}
      <text x="256" y="45" textAnchor="middle" fill="currentColor" fontSize="28" fontWeight="bold" fontFamily="Arial, sans-serif" opacity="0.8">N</text>
      <text x="256" y="495" textAnchor="middle" fill="currentColor" fontSize="28" fontWeight="bold" fontFamily="Arial, sans-serif" opacity="0.8">S</text>
      <text x="30" y="264" textAnchor="middle" fill="currentColor" fontSize="28" fontWeight="bold" fontFamily="Arial, sans-serif" opacity="0.8">W</text>
      <text x="482" y="264" textAnchor="middle" fill="currentColor" fontSize="28" fontWeight="bold" fontFamily="Arial, sans-serif" opacity="0.8">E</text>
      
      {/* Center Zia sun circle */}
      <circle cx="256" cy="256" r="55" fill="currentColor"/>
      
      {/* Zia rays - North (4 parallel lines) */}
      <g>
        <rect x="244" y="80" width="24" height="110" fill="currentColor" rx="3"/>
        <rect x="228" y="100" width="14" height="70" fill="currentColor" rx="2"/>
        <rect x="270" y="100" width="14" height="70" fill="currentColor" rx="2"/>
        <rect x="214" y="115" width="10" height="45" fill="currentColor" rx="2"/>
        <rect x="288" y="115" width="10" height="45" fill="currentColor" rx="2"/>
      </g>
      
      {/* Zia rays - South (4 parallel lines) */}
      <g>
        <rect x="244" y="322" width="24" height="110" fill="currentColor" rx="3"/>
        <rect x="228" y="342" width="14" height="70" fill="currentColor" rx="2"/>
        <rect x="270" y="342" width="14" height="70" fill="currentColor" rx="2"/>
        <rect x="214" y="352" width="10" height="45" fill="currentColor" rx="2"/>
        <rect x="288" y="352" width="10" height="45" fill="currentColor" rx="2"/>
      </g>
      
      {/* Zia rays - West (4 parallel lines) */}
      <g>
        <rect x="80" y="244" width="110" height="24" fill="currentColor" rx="3"/>
        <rect x="100" y="228" width="70" height="14" fill="currentColor" rx="2"/>
        <rect x="100" y="270" width="70" height="14" fill="currentColor" rx="2"/>
        <rect x="115" y="214" width="45" height="10" fill="currentColor" rx="2"/>
        <rect x="115" y="288" width="45" height="10" fill="currentColor" rx="2"/>
      </g>
      
      {/* Zia rays - East (4 parallel lines) */}
      <g>
        <rect x="322" y="244" width="110" height="24" fill="currentColor" rx="3"/>
        <rect x="342" y="228" width="70" height="14" fill="currentColor" rx="2"/>
        <rect x="342" y="270" width="70" height="14" fill="currentColor" rx="2"/>
        <rect x="352" y="214" width="45" height="10" fill="currentColor" rx="2"/>
        <rect x="352" y="288" width="45" height="10" fill="currentColor" rx="2"/>
      </g>
    </SvgIcon>
  );
};

export default ZiaCompassIcon;
